'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _VstComponent2 = require('./VstComponent');

var _VstComponent3 = _interopRequireDefault(_VstComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var svgSortIcon = function svgSortIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '6',
      height: '10',
      viewBox: '0 0 6 10',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement(
      'title',
      null,
      'Sort Icon'
    ),
    _react2.default.createElement(
      'g',
      {
        fill: '#DADADA',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        d: 'M6 6l-3 4-3-4zM0 4l3-4 3 4z'
      })
    )
  );
};

var VstTableHeader = function (_VstComponent) {
  _inherits(VstTableHeader, _VstComponent);

  function VstTableHeader() {
    _classCallCheck(this, VstTableHeader);

    return _possibleConstructorReturn(this, (VstTableHeader.__proto__ || Object.getPrototypeOf(VstTableHeader)).apply(this, arguments));
  }

  _createClass(VstTableHeader, [{
    key: '_capitalizeFirst',
    value: function _capitalizeFirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var children = _react2.default.Children.map(this.props.children, function (child, index) {
        if (child) {
          return _react2.default.createElement(
            'th',
            { key: 'header-cell-' + index },
            _react2.default.createElement(
              'button',
              { onClick: function onClick() {
                  return _this2.props.onClick(index);
                } },
              _react2.default.createElement(
                'span',
                null,
                _this2._capitalizeFirst(child),
                ' ',
                _react2.default.createElement(
                  'span',
                  { className: 'sortIcon', role: 'presentation' },
                  svgSortIcon()
                )
              )
            )
          );
        }
        return _react2.default.createElement(
          'th',
          { key: 'header-cell-' + index },
          _react2.default.createElement(
            'button',
            null,
            _react2.default.createElement('span', null)
          )
        );
      });

      return _react2.default.createElement(
        'thead',
        null,
        _react2.default.createElement(
          'tr',
          null,
          children,
          _react2.default.createElement(
            'th',
            { className: 'vst-table-col-hidden', key: 'header-cell- ' + children.length },
            _react2.default.createElement('div', null)
          )
        )
      );
    }
  }]);

  return VstTableHeader;
}(_VstComponent3.default);

exports.default = VstTableHeader;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstTableHeader.js
 **/